module.exports = __webpack_public_path__ + "img/y-c.91c5f047.png";